<template>
  <div class="shopDetails" style="margin-top: 220px;">
    <div class="shop-carBox comWidth">
      <div class="z_goods">
        <div class="z_goods_left picFocus">
          <div class="goods_banner">
            <div class="one">
              <!--<img :src="((goodsDetail.gallery)[0]).img_url" alt="极草经典含片0.25克*60片 图1">-->
              <img :src="imgBig" alt="极草经典含片0.25克*60片 图3">
            </div>
          </div>
          <div class="goods_banner_u">
            <ul class="goods_u" ref="goodsU">
              <li v-for=" ( listSrc , index ) in gallery" @click="switchPhoto(listSrc , index)" :key="listSrc.id"  :class="{ on: currentIndex == index }">
                <img :src="listSrc.image_url" alt="极草经典含片0.25克*60片 图1"></li>
            <!--  <li class="on"><img src="../../assets/ce/16_G_1500599490136.jpg" alt="极草经典含片0.25克*60片 图2"></li>
              <li class=""><img src="../../assets/ce/16_G_1500599490136.jpg" alt="极草经典含片0.25克*60片 图3"></li>
              <li class=""><img src="../../assets/ce/16_G_1500599490136.jpg" alt="极草经典含片0.25克*60片 图3"></li>
              <li class=""><img src="../../assets/ce/16_G_1500599490136.jpg" alt="极草经典含片0.25克*60片 图3"></li>-->
            </ul>
              <div class="bannerbtn1" @click="bannerbtnOne"><img src="../../assets/icon/goods_bannerbtn1.jpg" alt="上一張"></div>
              <div class="bannerbtn2" @click="bannerbtnTwo"><img src="../../assets/icon/goods_bannerbtn2.jpg" alt="下一張"></div>
          </div>
        </div>
        <div class="z_goods_right">
          <form  name="ECS_FORMBUY" id="ECS_FORMBUY" >
            <div class="one">
              <img src="../../assets/icon/goods1.png" alt="">
              <span>澳門&nbsp;&nbsp;|&nbsp;&nbsp;冬蟲夏草</span>
            </div>
            <div class="two">
              <h3>{{goodsDetail.goods_name}}</h3>
              <p>全面通過澳門衛生局、食品安全中心規定的產品安全與品質標準檢驗。澳門製造！</p>
            </div>
            <div class="three">
              <span>售價</span>
              <p>¥ {{goodsDetail.price}}  </p>
            </div>
            <ul class="four">
              <li>
                <b>稅費</b>
                <p><span>【包稅】</span>本商品已包稅，無需再額外繳納</p>
              </li>
       <!--       <li>
                <b>運費</b>
                <div class="on"><span>【包郵】</span>澳門&nbsp;&nbsp;至
                  <select name="carlist" form="carform">
                    <option value="volvo">四川成都</option>
                  </select>
                  預計7-15天內送達。</div>
              </li>-->
              <li>
                <b>運費</b>
                <div class="on"><span>【包郵】</span>澳門发货&nbsp;
                  <!--<span v-if="goodsDetail.id==26">預計6.18號開始發貨</span>-->
                  <!--<span v-else>預計7-15天內送達。</span>-->
                  <span>預計7-15天內送達。</span>
                  </div>
              </li>
              <li>
                <b>服務</b>
                <p>本商品由<span>澳門</span>發貨</p>
              </li>

              <li>
                <b>數量</b>
                <input class="min" ref="min" type="button" value="-" @click="reduceNum" />
                <button class="text_box">{{num}}</button>
                <input class="add" name="" type="button" value="+" @click="addNum" />
                <!--<el-input-number v-model="num1" @change="handleChange" :min="1" :max="10" label="描述文字"></el-input-number>-->
                <span class="span2">庫存緊張</span>
              </li>
              <li class="sm">
                <b>說明</b>
                <img src="../../assets/icon/goods2.png" alt="說明">
                <p>不支持7天無理由退貨，澳門商品不支持發票</p>
              </li>
            </ul>
            <div class="five">
              <button type="button" class="shopbuy-now ons btns" @click="purchaseImmediately">立即購買</button>

              <button type="button" class="ts btns" @click="addCart">加入購物車</button>
              <a class="tw" @click="joinTheCollector" v-if="goodsDetail.is_favorite == 0"><img src="../../assets/icon/z_sc.svg" alt="收藏">收藏</a>
              <a class="tw" @click="removeFavorites" v-if="goodsDetail.is_favorite == 1"><img src="../../assets/icon/z_qc.svg" alt="收藏">收藏</a>
            </div>
            <div class="sex">
              <el-rate
                v-model="value5"
                disabled
                text-color="#ff9900"
                score-template="{value}">
              </el-rate>
              <p>{{total}}人評論</p>
            </div>
        </form>
      </div>
    </div>
    </div>

    <div class="shop_list">

      <el-tabs type="border-card">
        <!--title-->
        <el-tab-pane label="商品詳情">
          <div class="one">
            <p v-html="goodsDetail.desc_pc"></p>
          </div>
        </el-tab-pane>

        <el-tab-pane label="用戶評論">
          <div class="one">
            <div id="ECS_COMMENT">
              <div class="box">
                <div class="box_1">
                  <h3><span class="text">用戶評論</span>(共<span class="f1">{{total}}</span>條評論)</h3>
                  <div class="boxCenterList" >
                    <ul class="comments">
                      <li class="word" v-for="item in commentList" :key="item.id">
                        <span class="f2">{{(item.user.username).replace(((item.user.username)).substring(3,7),'****')}}</span> <span class="f3">({{item.created_at}})</span><br />
                        <el-rate
                          v-model="item.star"
                          disabled
                          show-score
                          text-color="#ff9900"
                          score-template="{value}">
                        </el-rate>
                        <p>{{item.comment_reply_desc}}</p>
                      </li>
                    </ul>
                    <div id="pagebar" class="f_r">
                      <span id="pager">總計 {{total}} 個記錄，共 {{total_pages}} 頁。</span>
                      <el-pagination
                        background
                        layout="prev, pager, next"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :total= 'total'
                        :page-size="pageSize">
                      </el-pagination>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>

        <el-tab-pane label="大礼包">
          <div class="one big" v-for="item in shoppingMallList" :key="item.id">
            <h3 style="color: #676666;padding: 10px;">{{item.gift_name}}</h3>
            <ul>
              <li v-for="list in item.goods" :key="list.id">
                <div class="content">
                  <a>
                    <img :src="list.goods_thumb_url">
                  </a>
                  <div class="word-mian">
                    <a>
                      <h5>{{list.goods_name}}</h5>
                      <p>
                        <span class="price">￥{{list.price}}元</span>
                      </p>
                    </a>
                  </div>
                </div>
                <div class="add">
                  <i class="el-icon-plus"></i>
                </div>
              </li>
            </ul>
            <div class="rig">
              <p style="text-decoration: line-through;color: #b7b7b7">原价 : <span style="color:  #b7b7b7" class="price">￥{{item.price}}元</span></p>
              <p>礼包价 : <span class="price">￥{{(item.price - item.worth).toFixed(2)}}元</span></p>
              <button type="button" class="btns ons" @click="buyBigBagAtOnce(item)">立即購買</button>
            </div>
          </div>
        </el-tab-pane>

        <el-tab-pane label="优惠券">
          <div class="one coupon">
            <ul>
              <li v-for="item in shoppingCouponsList" :key="item.id">
                <div class="box_one">
                  <div class="juan">
                    <h5>{{item.coupon_name}}</h5>
                    <p>
                      <i></i>
                      <span>单笔满&yen;{{item.pay}}可用</span>
                    </p>
                  </div>
                  <div class="qian">
                    <span>&yen;</span>
                    <span class="price_num">{{item.worth}}</span>
                  </div>
                </div>
                <div class="top">
                  <button type="button" class="btns ons" @click="immediatelyReceive(item)">立即领取</button>
                </div>
              </li>
    <!--          <li>
                <div class="box_one">
                  <div class="juan">
                    <h5>优惠券</h5>
                    <p>
                      <i></i>
                      <span>单笔满&yen;222可用</span>
                    </p>
                  </div>
                  <div class="qian">
                    <span>&yen;</span>
                    <span class="price_num">5000.00</span>
                  </div>
                </div>
                <div class="top">
                  &lt;!&ndash;<button type="button" class="btns ons">立即领取</button>&ndash;&gt;
                  <button type="button" class="btns yi">已领取</button>
                </div>
              </li>-->
            </ul>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!--导航-->
    <NavB :titleChild="titleChild"/>
  </div>
</template>

<script>
  import NavB from '@/pages/detailsPage/NavB'
  //common.js
  import {setLocalStorage, getLocalStorage,ifSignIn} from '@/utils/common';
  import { getToken } from '@/utils/auts'
  //API
  import {reviewList ,commonPage} from '@/api/comment';
  import {collectionGood , collectionCancel} from '@/api/collection';
  import {listOfGoodsDetail} from '@/api/goods';
  import {shoppingMall, shoppingCoupons, receiveCoupons} from '@/api/activity';
  import {userInformation} from '@/api/authentication';
  import { Loading } from 'element-ui';
export default {
  name: 'ShopDetails',
  components:{
     NavB
  },
  data () {
    return {
      currentIndex:0,
      value5: 0,
      titles: '服務門店',
      titleChild:[{name:'首頁',src:'HomePage'},{name:'極草產品',src:'ProductPage'},{name:' ',src:'ShopDetails'}],
      //评论数据长度
      total:0,//总长度
      pageSize:0,//每页显示数据
      total_pages:0,//页数
      num: 1,
      //详情数据
      goodsDetail:{},
      //商品相册
      displacement : 0,
      //需要加入购物车的数据
      shopDataList :[],
      //评论列表
      commentList:[],
      //商品大图
      imgBig:'',
      gallery:[],
      //商品id
      goods:this.$route.query.id,
      // 大礼包
      shoppingMallList:[],
      // 优惠券
      shoppingCouponsList:[],
      /*登陆后的用户信息*/
      is_validated:undefined
    }
  },
  methods:{
    /*商品数量减*/
    reduceNum(){
        if(this.num <= 1){
          this.num = 1;
          this.$refs.min.style.cursor = 'not-allowed'
        }else {
            this.num --;
          this.$refs.min.style.cursor = 'pointer'
        }
    },
    /*商品数量加*/
    addNum(){
      this.num ++;
      this.$refs.min.style.cursor = 'pointer'
    },

    /*点击上一张*/
    bannerbtnOne(){
      var goodsImg = document.getElementsByClassName('goods_u')[0];
      goodsImg.style.transform = `translateX(${this.displacement}px)`
      if(this.displacement >= 0){
        this.displacement = 0;
        goodsImg.style.transform = `translateX(0px)`
      }else {
        this.displacement += 100;
      }
    },

    /*点击下一张*/
    bannerbtnTwo(){
      var goodsImg = document.getElementsByClassName('goods_u')[0];
      var goodsImgLength = goodsImg.children.length;
      goodsImg.style.transform = `translateX(${this.displacement}px)`;
      if(Math.abs(this.displacement) >= goodsImgLength * 100){
        this.displacement = -(goodsImgLength * 100);
      }else if(goodsImgLength == 3){
        this.displacement = 0;
      }else {
        this.displacement -= 100;
      }
    },

    /*点击图片切换*/
    switchPhoto(item , index){
      this.imgBig = item.image_url;
      this.currentIndex = index;
    },

    /*获取详情数据*/
    getGoodsDetail(){
/*      getLocalStorage('goodsDetail' ,  (res) => {
        this.goodsDetail = res;
        this.imgBig = (this.goodsDetail.gallery.data)[0].image_url;

      });*/
       let loadingInstance = Loading.service({ fullscreen: true });
       listOfGoodsDetail(this.goods).then(res=>{
           if (res){
             loadingInstance.close()
           }
         this.goodsDetail = res.data;
         this.value5 = res.data.star;
         this.titleChild[2].name = res.data.goods_name
         this.gallery = this.goodsDetail.gallery.data;
         this.imgBig = (res.data.gallery.data)[0].image_url;
       })
    },

    /*加入购物车*/
    addCart(){
      //判断是否登录
      ifSignIn(this, () =>{
        if (this.is_validated == 0) { //判断是否实名认证
          this.$confirm('您還未實名認證，是否前往實名認證?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            lockScroll:false,
          }).then(() => {
            this.$router.push({name: 'RealName'});
          }).catch(() => {
          });
        } else {
          this.purchaseData('ShoppingCart', undefined, undefined)
        }
      })
    },

    /*立即购买*/
    purchaseImmediately(){
      //判断是否登录
      ifSignIn(this, () =>{
        if (this.is_validated == 0) { //判断是否实名认证
          this.$confirm('您還未實名認證，是否前往實名認證?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            lockScroll:false,
          }).then(() => {
            this.$router.push({name: 'RealName'});
          }).catch(() => {
          });
        } else {
          this.purchaseData('SettlementShop', undefined, undefined);
          //存入立即购买数据
          var purchaseData = [];
          purchaseData.push(this.goodsDetail);
          purchaseData.forEach(item => {
            setLocalStorage('price', (item.num * item.price).toFixed(2));
            return item.smallPlan = (item.num * item.price).toFixed(2)
          });
          setLocalStorage('purchaseData', purchaseData)
        }
      });
    },

    /*立即购买大禮包*/
    buyBigBagAtOnce(item){
      //判断是否登录
      ifSignIn(this, () => {
        if (this.is_validated == 0) { //判断是否实名认证
          this.$confirm('您還未實名認證，是否前往實名認證?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            lockScroll:false,
          }).then(() => {
            this.$router.push({name: 'RealName'});
          }).catch(() => {
          });
        } else {
        this.purchaseData('SettlementShop', item.id, 'gift');
        //存入立即购买数据
        var purchaseData = [];
        purchaseData = (item.goods);
        /*     purchaseData.forEach(list =>{

          return list.smallPlan = (item.number * item.price).toFixed(2)
        })
        purchaseData.forEach(list =>{
          return  list.num = item.number
        })*/
        for (var i = 0; i < purchaseData.length; i++) {
          purchaseData[i].num = item.goods[i].number
          purchaseData[i].smallPlan = (parseFloat(item.goods[i].number) * parseFloat(item.goods[i].price)).toFixed(2)
        }
          setLocalStorage('price', (item.price - item.worth).toFixed(2));
          setLocalStorage('purchaseData', purchaseData)
         }
      });
    },

    /*购物车数据*/
    purchaseData(path,id,gift){
      this.goodsDetail.num = this.num;
      var shopDataLists = [];
      shopDataLists.push(this.goodsDetail);
      if(this.goodsDetail){
        //取出购物车数据
        getLocalStorage('shopDataLists' ,  (res) => {
          shopDataLists = res;
          //如果有数据，判断是否重复加入购物车
          if(res){
            if(shopDataLists.some(this.shopData)){}
            else {
              shopDataLists.push(this.goodsDetail)
            }
          }
        });
        //数据存储
        setLocalStorage('shopDataLists' , shopDataLists)
        this.$router.push({name:path,query:{id:id,gift:gift}});
      }
    },

    /*判断购物车数据是否相同*/
    shopData(shop){
      if(shop.id == this.goodsDetail.id){
        return  shop.num = parseFloat(this.goodsDetail.num) +　parseFloat(shop.num);
      }else {
        return  false;
      }
    },

    /*加入收藏夹*/
    joinTheCollector(){
      if (!this.$store.state.user.token){
        this.$message.warning('請先登錄')
        return false
      }else {
        collectionGood(this.goodsDetail.id).then(res =>{
          this.$message.success('收藏成功');
          this.goodsDetail.is_favorite = 1;
        })
      }
    },

    /*移除收藏夹*/
    removeFavorites(){
      if (!this.$store.state.user.token){
        this.$message.warning('請先登錄')
        return false
      }else {
        collectionCancel(this.goodsDetail.id).then(res =>{
          this.$message.success('移除收藏成功');
          this.goodsDetail.is_favorite = 0;
        })
      }
    },

    /*获取评论列表*/
    getComments(){
      reviewList(this.goods).then(res=>{
        this.commentList = res.data.data;
        this.total = res.data.meta.pagination.total;
        this.pageSize = res.data.meta.pagination.per_page;
        this.total_pages = res.data.meta.pagination.total_pages;
      })
    },

    /*获取商城大礼包*/
    getShoppingMallList(){
      shoppingMall(this.goods).then(res =>{
        this.shoppingMallList = res.data.data
      })
    },

    /*获取商城优惠券*/
    getShoppingCouponsList(){
//        alert(this.goods)
      shoppingCoupons(this.goods).then(res =>{
        this.shoppingCouponsList = res.data.data
      })
    },

    /*点击立即领取*/
    immediatelyReceive(item){
      if (!this.$store.state.user.token){
        this.$message.warning('請先登錄')
        return false
      }else {
        receiveCoupons(item.id).then(res =>{
          this.$message.success('領取成功')
        })
      }
    },

    /*评论分页*/
    pagingS(page){
      commonPage(this.goodsDetail.id,page).then(res =>{
        this.commentList = res.data.data;
      })
    },
    handleCurrentChange(val) {
      this.pagingS(val)
    },
    handleSizeChange(val) {
    },

    /*获取登陆后的个人信息*/
    getInformation(){
      if (getToken()){
        userInformation().then(res =>{
          this.is_validated = res.data.is_validated;
        })
      }
    }
  },
  created(){
    // 获取登陆后的个人信息
    this.getInformation()
    //获取详情数据
    this.getGoodsDetail()
    //获取评论列表
    this.getComments()
    // 获取商城大礼包
    this.getShoppingMallList()
    // 获取商城优惠券
    this.getShoppingCouponsList()
    window.scrollTo(0,0)

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import "../../css/shopDetails.less";
</style>



// WEBPACK FOOTER //
// src/pages/detailsPage/ShopDetails.vue